import { ReactComponent as LoginImage } from "./login-required.svg";
import { ReactComponent as TSLogo } from "./ts-logo.svg";
import { ReactComponent as HoldTight } from "./hold-tight.svg";
import { ReactComponent as NotFoundImage } from "./404-img.svg";
import { ReactComponent as AccessDenied } from "./404-img.svg";

export { LoginImage, TSLogo, HoldTight, NotFoundImage, AccessDenied };
